export default {
    methods: {
        getType(slug) {
            switch (slug) {
                case 'MultiplicationAndDivision':
                    return 'MultiplicationAndDivision';
                case 'AssembleTheNumber':
                    return 'AssembleTheNumber';
                case 'FlashCards':
                case 'InteractiveFlashCards':
                    return 'FlashCards';
                case 'AdditionAndSubtraction':
                case 'AdditionAndSubtractionWithTime':
                case 'AdditionAndSubtractionMathMagic':
                    return 'AdditionAndSubtraction';
                case 'MultiplicationAndDivisionCourse':
                    return 'MultiplicationAndDivisionCourse';
                case 'Equation':
                    return 'Equation';
                case 'Factorization':
                    return 'Factorization';
                case 'EquationMultiplication':
                    return 'EquationMultiplication';
                case 'EquationOnline':
                    return 'EquationOnline';
                case 'Anzan':
                case 'AnzanWithTime':
                    return 'Anzan';
                case 'Puzzle':
                    return 'Puzzle';
                case 'Couples':
                case 'CouplesWithTime':
                case 'CouplesMemoryDevelopment':
                case 'CouplesMemoryDevelopmentWithTime':
                    return 'Couples';
                case 'Chains':
                case 'ChainsWithTime':
                    return 'Chains';
                case 'Schulte':
                    return 'Schulte';
                case 'Scanner':
                case 'ScannerWithTime':
                    return 'Scanner';
                case 'Shutter':
                case 'ShutterOnline':
                    return 'Shutter';
                case 'ShutterRussianLanguage':
                    return 'ShutterRussianLanguage';
                case 'WordsField':
                case 'WordsFieldWithTime':
                case 'WordsFieldOnline':
                case 'WordsFieldOnlineWithTime':
                    return 'WordsField';
                case 'Anagrams':
                case 'AnagramsWithTime':
                case 'AnagramsOnline':
                case 'AnagramsOnlineWithTime':
                    return 'Anagrams';
                case 'Texts':
                case 'TextsWithTime':
                case 'TextsOnline':
                case 'TextsOnlineWithTime':
                    return 'Texts';
                case 'LettersField':
                case 'LettersFieldOnline':
                    return 'LettersField';
                case 'CatchWord':
                case 'CatchWordOnline':
                    return 'CatchWord';
                case 'VisionField':
                    return 'VisionField';
                case 'Navigator':
                    return 'Navigator';
                case 'Matrix':
                case 'MatrixWithTime':
                    return 'Matrix';
                case 'Memorize':
                    return 'Memorize';
                case 'KeenEye':
                    return 'KeenEye';
                case 'NumericalNetwork':
                    return 'NumericalNetwork';
                case 'Synonyms':
                case 'SynonymsOnline':
                    return 'Synonyms';
                case 'Presentations':
                    return 'Presentations';
                case 'Antonyms':
                    return 'Antonyms';
                case 'Search':
                    return 'Search';
                case 'Classifications':
                    return 'Classifications';
                case 'Loner':
                    return 'Loner';
                case 'Abacus':
                    return 'Abacus';
                case 'RootsAndDegrees':
                    return 'RootsAndDegrees';
                case 'RootsAndSquares':
                    return 'RootsAndSquares';
                case 'SequenceOfNumbers':
                    return 'SequenceOfNumbers';
                case 'Associations':
                    return 'Associations';
                case 'WhoIsWho':
                case 'WhoIsWhoWithTime':
                    return 'WhoIsWho';
                case 'CosmoTour':
                    return 'CosmoTour';
                case 'CorrectiveSamplesWithTime':
                case 'CorrectiveSamples':
                    return 'CorrectiveSamples';
                case 'ChainsBonusGame':
                case 'ChainsBonusGameWithTime':
                    return 'ChainsBonusGame';
                case 'Diada':
                case 'DiadaWithTime':
                    return 'Diada';
                case 'ChainsReadingEn':
                case 'ChainsReadingEnWithTime':
                case 'ChainsReadingEnWithoutTime':
                    return 'ChainsReadingEn';
                case 'CouplesReadingEn':
                case 'CouplesReadingEnWithTime':
                case 'CouplesReadingEnWithoutTime':
                    return 'CouplesReadingEn';
                case 'WordsFieldReadingEn':
                case 'WordsFieldReadingEnWithTime':
                case 'WordsFieldReadingEnWithoutTime':
                    return 'WordsFieldReadingEn';
                case 'CatchWordReadingEn':
                    return 'CatchWordReadingEn';
                case 'VisionFieldReadingEn':
                    return 'VisionFieldReadingEn';
                case 'TransferSyllables':
                    return 'TransferSyllables';
                case 'TransferSyllablesSchoolPreparing':
                    return 'TransferSyllablesSchoolPreparing';
                case 'DivideItRight':
                    return 'DivideItRight';
                case 'ChooseItRight':
                    return 'ChooseItRight';
                case 'DivideUnstressedVowels':
                    return 'DivideUnstressedVowels';
                case 'VocabularyWordsRus':
                    return 'VocabularyWordsRus';
                case 'LettersSoundsSyllables':
                    return 'LettersSoundsSyllables';
                case 'SynonymsRussianLanguage':
                    return 'SynonymsRussianLanguage';
                case 'AntonymsRussianLanguage':
                    return 'AntonymsRussianLanguage';
                case 'HardSoftConsonants':
                    return 'HardSoftConsonants';
                case 'HardSoftConsonantsSchoolPreparing':
                    return 'HardSoftConsonantsSchoolPreparing';
                case 'TranscriptionInWord':
                    return 'TranscriptionInWord';
                case 'VoicedAndDeafConsonants':
                    return 'VoicedAndDeafConsonants';
                case 'PunctuationMarks':
                    return 'PunctuationMarks';
                case 'WordDrum':
                    return 'WordDrum';
                case 'VocabularyMemoRus':
                    return 'VocabularyMemoRus';
                case 'PartsOfSpeech':
                    return 'PartsOfSpeech';
                case 'ParsingSentencePartsSpeech':
                    return 'ParsingSentencePartsSpeech';
                case 'SortOneMany':
                    return 'SortOneMany';
                case 'GenericWords':
                    return 'GenericWords';
                case 'VerbTenses':
                    return 'VerbTenses';
                case 'WordStructure':
                    return 'WordStructure';
                case 'SentenceParsing':
                    return 'SentenceParsing';
                default:
                    return slug;
            }
        },
    },
};
